/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
(function () {
    const HASH = '#home-custom-collection';
    const SELECTOR = '#home-custom-collection';
    const HEADER_SELECTOR = '.header'; // adjust if needed
    const BUFFER = 20; // extra breathing room
  
    if (location.hash !== HASH) return;
  
    // 1) Prevent the browser’s native anchor jump
    const urlNoHash = location.pathname + location.search;
    history.replaceState(null, '', urlNoHash);
  
    function getHeaderHeight() {
      const header = document.querySelector(HEADER_SELECTOR);
      return header ? header.getBoundingClientRect().height : 0;
    }
  
    function getTargetTop(el) {
      return el.getBoundingClientRect().top + window.scrollY;
    }
  
    function scrollWithOffset(el, smooth = true) {
      const finalTop = Math.max(0, getTargetTop(el) - getHeaderHeight() - BUFFER);
      window.scrollTo({ top: finalTop, behavior: smooth ? 'smooth' : 'auto' });
    }
  
    window.addEventListener('load', () => {
      const target = document.querySelector(SELECTOR);
      if (!target) return;
  
      // 2) Do the main smooth scroll
      scrollWithOffset(target, true);
  
      // 3) Final correction after scrolling finishes (handles late header/font changes)
      const correct = () => {
        scrollWithOffset(target, false);     // snap exactly to the computed spot
        history.pushState(null, '', HASH);   // restore the hash without triggering a jump
      };
  
      if ('onscrollend' in window) {
        window.addEventListener('scrollend', correct, { once: true });
      } else {
        // Fallback timeout roughly matching smooth scroll duration
        setTimeout(correct, 0);
      }
    }, { once: true });
  })();
  